export default __webpack_public_path__ + "static/media/article-6.5d410173.png";